const state = {
  selectShotType: [],
  selectAllStaff: [],
  shopList: [],
  storeMarket: [],
}

const getters = {
  selectShotType: state => {
    return state.selectShotType
  },
  selectAllStaff: state => {
    return state.selectAllStaff
  },
  shopList: state => {
    return state.shopList
  },
  storeMarket: state => {
    return state.storeMarket
  }

}

const mutations = {
  setSelectShotType: (state, data) => {
    if (!data) {
      state.selectShotType = []
    } else {
      state.selectShotType = data
    }
  },
  setSelectAllStaff: (state, data) => {
    return state.selectAllStaff = data
  },
  setShopList: (state, data) => {
    return state.shopList = data
  },
  setStoreMarket:(state,data)=>{
    return state.storeMarket = data
  }
}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/kz-condition/entry-select.js